import { Routes } from '@angular/router';
import { LayoutComponent } from './components/layout/layout.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { UsersComponent } from './components/users/users.component';
import { RolesComponent } from './components/roles/roles.component';
import { PagesComponent } from './components/pages/pages.component';
import { PermissionsComponent } from './components/permissions/permissions.component';
import { PageProcessesComponent } from './components/page-processes/page-processes.component';
import { CoverPagesComponent } from './components/cover-pages/cover-pages.component';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { LandingComponent } from './components/landing/landing.component';
import { authGuard } from './guards/auth.guard';
import { adminGuard } from './guards/admin.guard';
import { empresaGuard } from './guards/empresa.guard';
import { landingGuard } from './guards/landing.guard';

export const routes: Routes = [
  {
    path: '',
    component: LandingComponent,
    canActivate: [landingGuard],
  },
  {
    path: 'landing',
    component: LandingComponent,
    canActivate: [landingGuard],
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'register',
    component: RegisterComponent
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent, canActivate: [empresaGuard] },
      { path: 'pages', component: PagesComponent, canActivate: [empresaGuard] },
      { path: 'processes', component: PageProcessesComponent, canActivate: [empresaGuard] },
      { path: 'users', component: UsersComponent, canActivate: [adminGuard] },
      { path: 'roles', component: RolesComponent, canActivate: [adminGuard] },
      { path: 'permissions', component: PermissionsComponent, canActivate: [adminGuard] },
      { path: 'cover-pages', component: CoverPagesComponent, canActivate: [adminGuard] },
    ],
  },
  { path: '**', redirectTo: 'login' },
];
